<template>
  <div class="mv-bg-main">
    <el-card >
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" ref="searchForm" :model="form" label-width="100px" class="demo-form-inline ">
        <el-form-item label="业务系统" prop="value8">
          <el-select v-model="form.sysId" clearable filterable placeholder="请选择业务系统">
            <el-option
              v-for="item in sysData"
              :key="item.systemId"
              :label="item.systemName"
              :value="item.systemId" >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号码或电子邮箱"></el-input>
        </el-form-item>
        <el-form-item label="操作类型" prop="operate">
          <el-select v-model="form.operate" clearable filterable placeholder="请选择操作类型">
            <el-option
              label="注册"
              value="1" >
            </el-option>
            <el-option
              label="登录"
              value="2" >
            </el-option>
            <el-option
              label="退出"
              value="3" >
            </el-option>
            <el-option
              label="找回密码"
              value="4" >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="float-r">
          <el-button size="small" @click="onReset('searchForm')">重置</el-button>
          <el-button type="primary" size="small" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-top">
      <div slot="header" class="clearfix">
        <span class="card-title">查询结果</span>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="系统名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账户"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.account }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.operateType === '1' ? '注册' : scope.row.operateType === '2' ? '登录' : scope.row.operateType === '3' ? '退出' : '找回密码'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作时间"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作结果"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.operateResult }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="IP地址"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.ip }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="系统来源"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.custome-height {
  height: 700px;
  overflow-y: scroll;
}
.img {
  width: 100px;
  height: 100px;
}
.ml {
  margin-left: 10px;
}
.mt {
  margin-top: 10px;
}
.center {
  text-align: right;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.wid {
  flex: 1;
}
</style>
<script>
export default {
  name: 'userJournal',
  data () {
    return {
      form: {
        phone: '',
        operate: '',
        userId: '',
        sysId: ''
      },
      cusDialog: false,
      tableData: [],
      detailForm: {},
      tooltip: true,
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.query()
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
      this.form.phone = ''
      this.form.operate = ''
      this.form.userId = ''
      this.form.sysId = ''
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    changeStatus (index, val) {},
    query () {
      let op = {}
      let _this = this
      let id = this.form.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.sysIds = sysIds
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.registUserId = this.form.userId
      op.account = this.form.phone
      op.operateType = this.form.operate
      this.$axios({
        url: _this.$API.rechargeManagement.queryUserOperateLogByPage,
        // url: 'http://172.16.9.148:5010/agw/cucu/user/queryUserOperateLogByPage',
        method: 'post',
        data: op
      }).then((response) => {
        _this.tableData = response.data.resData.resultList
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.$store.dispatch('getSystem') // 请求业务系统
    let userId = this.$route.query.id
    let sysId = Number(this.$route.query.sysId)
    if (userId) {
      this.form.userId = userId
      this.form.sysId = sysId
    }
    this.query()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/userManagement/userJournal.vue